import * as React from "react";
import {
  Menu,
  MenuItemLink,
  useSidebarState,
  DashboardMenuItem,
} from "react-admin";
import {
  ListItemButton,
  ListItemIcon,
  ListItemText,

 
  Collapse,
  Box,
} from "@mui/material";
import QuizIcon from "@mui/icons-material/Quiz";
 
import LockIcon from "@mui/icons-material/Lock";
import FeedbackIcon from "@mui/icons-material/Feedback";
import DescriptionIcon from "@mui/icons-material/Description";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import PeopleIcon from "@mui/icons-material/People";
import GroupIcon from "@mui/icons-material/Group";
import SecurityIcon from "@mui/icons-material/Security";
import CategoryIcon from "@mui/icons-material/Category";
import AssignmentIcon from "@mui/icons-material/Assignment";
 
const MyMenu = (props) => {
  const [open] = useSidebarState();
 
  const [formsOpen, setFormsOpen] = React.useState(false);
  const [CertificateOpen, setCertificateOpen] = React.useState(false);
  const [rbacOpen, setRbacOpen] = React.useState(false);
  const [UserguideOpen, setCoursesOpen] = React.useState(false);
  const [assessmentOpen, setAssessmentOpen] = React.useState(false);
  
  return (
    <Menu {...props}>
      <DashboardMenuItem />
 {/* ===== COURSES MODULE ===== */}
<ListItemButton onClick={() => setCoursesOpen(!UserguideOpen)}>
  <ListItemIcon>
    <DescriptionIcon />
  </ListItemIcon>
  {open && <ListItemText primary="Userguide" />}
  {open && (UserguideOpen ? <ExpandLess /> : <ExpandMore />)}
</ListItemButton>

<Collapse in={UserguideOpen} timeout="auto" unmountOnExit>
  <Box sx={{ pl: 4 }}>
    <MenuItemLink to="/courses" primaryText="Category"  leftIcon={<CategoryIcon />} />
    <MenuItemLink to="/user-guides" primaryText="Uploads" leftIcon={<DescriptionIcon />} />
    <MenuItemLink to="/user-guide-assignments" primaryText="Assign" leftIcon={<AssignmentIcon />} />
  </Box>
</Collapse>
     {/* ===== FEEDBACK FORMS MODULE ===== */}
<ListItemButton onClick={() => setFormsOpen(!formsOpen)}>
  <ListItemIcon>
    <DescriptionIcon />
  </ListItemIcon>
  {open && <ListItemText primary="Feedback Form" />}
  {open && (formsOpen ? <ExpandLess /> : <ExpandMore />)}
</ListItemButton>
 
<Collapse in={formsOpen} timeout="auto" unmountOnExit>
  <Box sx={{ pl: 4 }}>
    <MenuItemLink to="/form-types" primaryText="Form Types" leftIcon={<CategoryIcon />} />
    <MenuItemLink to="/forms" primaryText="Forms" leftIcon={<FeedbackIcon/>}/>
    <MenuItemLink to="/feedback-type-summary" primaryText="Responses" leftIcon={<FeedbackIcon />}/>  

  </Box>
</Collapse>
 

 <ListItemButton onClick={() => setCertificateOpen(!CertificateOpen)}>
  <ListItemIcon>
    <DescriptionIcon />
  </ListItemIcon>
  {open && <ListItemText primary="Certificates" />}
  {open && (CertificateOpen? <ExpandLess /> : <ExpandMore />)}
</ListItemButton>
 
<Collapse in={CertificateOpen} timeout="auto" unmountOnExit>
  <Box sx={{ pl: 4 }}>
    <MenuItemLink to= "/certificate" primaryText="Uploads" leftIcon={<PeopleIcon />} />
          <MenuItemLink to= "/assign-certificate" primaryText="Assign" leftIcon={<PeopleIcon />} />
  </Box>
</Collapse>

 
      {/* ===== RBAC MODULE ===== */}
      <ListItemButton onClick={() => setRbacOpen(!rbacOpen)}>
        <ListItemIcon>
          <LockIcon />
        </ListItemIcon>
        {open && <ListItemText primary="RBAC" />}
        {open && (rbacOpen ? <ExpandLess /> : <ExpandMore />)}
      </ListItemButton>
 
      <Collapse in={rbacOpen} timeout="auto" unmountOnExit>
        <Box sx={{ pl: 4 }}>
 
 
          {/* <MenuItemLink to= "/certificate" primaryText="certificate" leftIcon={<PeopleIcon />} /> */}
                  <MenuItemLink to="/users" primaryText="Users" leftIcon={<PeopleIcon />} />
          <MenuItemLink to="/groups" primaryText="Groups" leftIcon={<GroupIcon />} />
          <MenuItemLink to="/roles" primaryText="Roles" leftIcon={<SecurityIcon />} />
          <MenuItemLink to="/permissions" primaryText="Permissions" leftIcon={<PeopleIcon />}/>
          <MenuItemLink to="/usergroups" primaryText="User Groups"leftIcon={<PeopleIcon />} />
          <MenuItemLink to="/grouproles" primaryText="Group Roles"leftIcon={<PeopleIcon />} />
          <MenuItemLink to="/rolepermissions" primaryText="Role Permissions" leftIcon={<PeopleIcon />} />
        </Box>
      </Collapse>

      {/* ===== ASSESSMENT MODULE ===== */}
<ListItemButton onClick={() => setAssessmentOpen(!assessmentOpen)}>
  <ListItemIcon>
    <QuizIcon />
  </ListItemIcon>
  {open && <ListItemText primary="Assessment" />}
  {open && (assessmentOpen ? <ExpandLess /> : <ExpandMore />)}
</ListItemButton>

<Collapse in={assessmentOpen} timeout="auto" unmountOnExit>
  <Box sx={{ pl: 4 }}>
    <MenuItemLink to="/categories" primaryText="Categories" leftIcon={<CategoryIcon />} />
    <MenuItemLink to="/questions" primaryText="Questions" leftIcon={<QuizIcon />} />
    <MenuItemLink to="/assessments" primaryText="Assessments" leftIcon={<AssignmentIcon />} />
    <MenuItemLink to="/assignments" primaryText="Assign" leftIcon={<AssignmentIcon />} />
    <MenuItemLink to="/all_attempts" primaryText="Responses" leftIcon={<AssignmentIcon />} />
  </Box>
</Collapse>
    </Menu>
  );
};
 
export default MyMenu;
 